const getConfig = () => {
    return window.AppSettings
}

const getHisTitle = () => {
    return window?.AppSettings?.his?.title[localStorage.getItem('language') ?? 'tr']
}

const AppConfig = {
    getConfig,
    getHisTitle
}

export default AppConfig;